// @todo This file should be removed together with styled components

export default {
  default: {
    // FONT
    fontNormal: 'Helvetica Neue LT W05 55 Roman, sans-serif',
    fontMedium: 'Helvetica Neue LT W05 65 Medium, sans-serif',
    fontBold: 'Helvetica Neue LT W05_75 Bold, sans-serif',
    fontLight: 'Helvetica Neue LT W05 45 Light, sans-serif',

    // TEXT
    textSizeRoot: '14px',
    textColorDefault: '#363839',
    textColorInverted: '#ffffff',
    textColorDim: '#6d7278',
    textColorDim2: '#a6a6a6',

    // COLORS
    colorPrimary: '#d3461e',
    colorInfo: '#60c1f0',
    colorWarning: '#EDA412',
    colorError: '#ff5252',
    colorSuccess: '#1da57a',
    colorDisabled: '#ddd',
    colorLevelNice: '#95c52d',
    colorLevelCritical: '#FF5C5C',
    colorLevelWarning: '#ffbf31',
    colorLevelCold: '#739ebc',

    // BACKGROUND
    backgroundNeutral: '#f1f1f1',
    backgroundElement: '#fff',
    backgroundCritical: '#efd5d5',
    backgroundElementInverted: '#130c0e',
    backgroundHighlighted: '#f8f8f8',
    backgroundWarningBox: '#f9e1db',

    // BORDERS
    borderColor: '#e6e6e6',
    borderColorDenser: '#d9d9d9',
  },

  propx: {
    // TEXT
    textSizeRoot: '14px',

    // FONT
    fontNormal: 'Helvetica Neue LT W05 55 Roman, sans-serif',
    fontMedium: 'Helvetica Neue LT W05 65 Medium, sans-serif',
    fontBold: 'Helvetica Neue LT W05_75 Bold, sans-serif',
    fontLight: 'Helvetica Neue LT W05 45 Light, sans-serif',

    textColorDefault: '#ffffff',
    textColorInverted: '#363839',
    textColorDim: '#b6b6b6',
    textColorDim2: '#777777',

    // COLORS
    colorPrimary: '#95c52d',
    colorInfo: '#60c1f0',
    colorWarning: '#EDA412',
    colorError: '#ff5252',
    colorSuccess: '#95c52d',
    colorDisabled: '#444',
    colorLevelNice: '#95c52d',
    colorLevelCritical: '#FF5C5C',
    colorLevelWarning: '#ffbf31',
    colorLevelCold: '#739ebc',

    // BACKGROUND
    backgroundNeutral: '#252323',
    backgroundElement: '#130c0e',
    backgroundCritical: '#401a1a',
    backgroundElementInverted: '#fff',
    backgroundHighlighted: '#080808',
    backgroundWarningBox: '#333',

    // BORDERS
    borderColor: '#444444',
    borderColorDenser: '#555',
  },
};
